import { FiChevronDown, FiArrowRight } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const domains = ['agri', 'finance', 'market'];

// Finance is a paid product: users without it never see the tab at all,
// rather than seeing it and being told to upgrade. Defaults to hidden so a
// still-loading plan can never flash a tab the user is not entitled to.
const visibleDomains = (allowFinance) =>
  domains.filter((domain) => domain !== 'finance' || allowFinance);
const tasks = {
  agri: ['diagnosis', 'photo', 'soil'],
  // #102: only the guided assessment remains; free typing in Finance is the
  // normal finance chat, so the two illustrative shortcuts were redundant.
  finance: ['case'],
  market: ['prices', 'compare', 'sell'],
};
// Still being tuned with credit officers: shown as a beta next to its name.
const beta = new Set(['case']);

export function DomainPicker({ value, onChange, compact = false, disabled = false, allowFinance = false }) {
  const { t } = useTranslation('workspace');
  const shown = visibleDomains(allowFinance);
  if (compact) return <label className="ws-domain-compact">
    <span className="ws-sr-only">{t('domainLabel')}</span>
    <select value={value} onChange={(event) => onChange(event.target.value)} disabled={disabled}>
      {shown.map((domain) => <option key={domain} value={domain}>{t(`domain_${domain}`)}</option>)}
    </select>
    <FiChevronDown aria-hidden="true" />
  </label>;
  return <div className="ws-domains" role="group" aria-label={t('domainLabel')}>
    {shown.map((domain) => <button key={domain} type="button" aria-pressed={value === domain}
      disabled={disabled} onClick={() => onChange(domain)}>{t(`domain_${domain}`)}</button>)}
  </div>;
}

export function DomainTasks({ domain, selected, onSelect, disabled }) {
  const { t } = useTranslation('workspace');
  return <section className="ws-domain-tasks" aria-label={t('tasksTitle')}>
    <h2>{t('tasksTitle')}</h2>
    <div className="ws-task-list">{tasks[domain].map((task) => <button key={task} type="button"
      disabled={disabled} aria-pressed={selected === task} onClick={() => onSelect(task)}>
      <span>{t(`task_${task}`)}{beta.has(task) && <span className="ws-beta" aria-hidden="true">{t('task_beta')}</span>}</span>
      <FiArrowRight aria-hidden="true" />
    </button>)}</div>
  </section>;
}
